import { Link, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("SLNAdminToken");
    navigate("/", { replace: true });
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg py-0 px-0 my-header-bg sticky-top z-5">
        <div className="container">
          <div className="d-flex align-items-center">
            <button
              class="navbar-toggler collapsed me-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar-default"
              aria-controls="navbar-default"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="icon-bar top-bar mt-0"></span>
              <span class="icon-bar middle-bar"></span>
              <span class="icon-bar bottom-bar"></span>
            </button>

            <Link to="/">
              <img
                src="/assets/images/logo.png"
                className="d-lg-none d-block"
                width="50"
              />
              <img
                src="/assets/images/logo.png"
                width="50"
                className="me-5 d-lg-block d-none"
              />
            </Link>
          </div>
          <div className="ms-auto d-flex align-items-center order-lg-3">
            <div>
              <div className="d-flex align-items-center">
                <div class="d-flex gap-1 align-items-center justify-content-end">
                  <a
                    href="https://www.facebook.com/profile.php?id=61586179350665"
                    target="_blank"
                    className="d-lg-block d-none"
                  >
                    <img src="/assets/images/facebook.png" width="30" />
                  </a>
                  <a
                    href="https://www.youtube.com/@SLNAcademyOfficial"
                    target="_blank"
                  >
                    <img src="/assets/images/youtube.png" width="30" />
                  </a>
                  <img
                    src="/assets/images/instagram.png"
                    width="30"
                    className="d-lg-block d-none"
                  />
                  <a
                    href="https://x.com/AcademySln64983"
                    target="_blank"
                    className="d-lg-block d-none"
                  >
                    <img src="/assets/images/x.png" width="30" />
                  </a>
                </div>
                <span
                  onClick={handleLogout}
                  class="btn btn-icon btn-danger rounded-circle d-none d-md-inline-flex ms-3"
                >
                  <i class="bi bi-power fs-4 align-middle"></i>
                </span>
              </div>
            </div>
          </div>
          <div className="collapse navbar-collapse" id="navbar-default">
            <ul className="navbar-nav  mt-3 mt-lg-0">
              <li class="nav-item">
                <Link class="nav-link" to="/manage/all-courses">
                  All Courses
                </Link>
              </li>
              <li class="nav-item dropdown">
                <Link
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarLanding"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Manage SLN Scan
                </Link>
                <ul class="dropdown-menu" aria-labelledby="navbarLanding">
                  <li>
                    <Link to="/manage/all-symbols" class="dropdown-item">
                      All Symbols
                    </Link>
                  </li>
                  <li>
                    <Link to="/manage/market-holidays" class="dropdown-item">
                      Manage Market Holidays
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/manage/update-fyers-token"
                      class="dropdown-item me-3"
                    >
                      Update Fyers Token
                    </Link>
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <Link class="nav-link" to="/manage/all-users">
                  Manage Users
                </Link>
              </li>
              <li class="nav-item">
                <Link class="nav-link" to="/manage/payments-history">
                  Manage Payment History
                </Link>
              </li>
              <li class="nav-item">
                <Link class="nav-link" to="/manage/all-coupons">
                  Manage Coupons
                </Link>
              </li>
              <li class="nav-item">
                <Link class="nav-link" to="/manage/reports">
                  Reports{" "}
                  <span class="badge bg-danger-soft fs-6 ms-2 px-3">Excel</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
